const regexFormatPassword = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])/g
const regexDateSafari = /-/g

export const Regex = {
  regexFormatPassword,
  regexDateSafari,
}
